export default __webpack_public_path__ + "3f8b113a82f7680f838deb1a508a0448.png";